<template>
  <section class="dashboard">
    <header class="title-header">
      <span class="back-btn" @click="goBack()">
        <img src="@/assets/images/ic_back.svg" alt />
      </span>
      <div class="money">
        <img src="@/assets/images/ic_money.svg" alt />
        <span>157</span>
      </div>
    </header>
    <ul class="tabing">
      <li :class="{'active':isActive=='uploaded'}" @click="changeStatus('uploaded')">Uploaded</li>
      <li :class="{'active':isActive=='live'}" @click="changeStatus('live')">Live News91</li>
      <li :class="{'active':isActive=='rejected'}"  @click="changeStatus('rejected')">Rejected</li>
    </ul>
    <div class="tab-content" v-if="!openAudioVideo">
      <div class="status">
        <h1>{{newsData && newsData.length}}</h1>
        <span class="text">{{isActive}} News</span>
        <span class="add-btn" @click="isCreateNewsPopUp = !isCreateNewsPopUp">
          <img src="@/assets/images/ic_add.svg" alt /> News Create
        </span>
      </div>
      <ul class="grid">
        <li v-for="(data, index) in newsData" v-if="newsData.length && showData" @click="openFile(data)">
          <div class="text">
            <p>{{data.news_title}}</p>
            <span>21 May 20</span>
          </div>
          <div class="picture">
            <img src="@/assets/images/audioMp3.svg" alt />
            <!-- <img class="play-icon" src="@/assets/images/multimedia.png" alt /> -->
          </div>
          <!-- <span class="bottom-block" v-if="isActive=='live'">Check News91 <img src="@/assets/images/double-arrow.svg" alt=""></span> -->
          <!-- <span class="bottom-block link" v-if="isActive=='rejected'"><small>Feedback:</small> ये न्यूज़ गलत जगह की है</span> -->
        </li>        
          <span class="bottom-block" @click="handleLoadMore">load more <img src="@/assets/images/double-arrow.svg" alt=""></span>
      </ul>
    </div>

    <div class="create-popup" v-if="isCreateNewsPopUp">
      <div class="content">
        <p>अपनी न्यूज़ बनाने के लिए इनमे से कोई एक ऑप्शन चुने</p>
        <span @click="isCreateNewsPopUp = !isCreateNewsPopUp">close</span>
        <div class="btns">
          <router-link :to="{path:'/audio-record?allTaskIndex=' + this.$route.query.allTaskIndex}" class="audio item" tag="div">
            <span class="audio_icon">
              <img src="@/assets/images/ic-mic.svg" alt />
            </span>
            <small>Audio Recording</small>
          </router-link>
          <router-link :to="{path:'/video-record?allTaskIndex=' + this.$route.query.allTaskIndex}" class="video item" tag="div">
            <span>
              <img src="@/assets/images/ic_video.svg" alt />
            </span>
            <small>Video Recording</small>
          </router-link>
        </div>
      </div>
    </div>
    <audio-preview :clickedNewsData="clickedNewsData" :getAudioData="recordedAudio" :totalTime="secondsOnly" v-if="recordedAudio" />
    <video-preview :clickedNewsData="clickedNewsData" :getVideoData="recordedVideo" v-if="recordedVideo" />
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="@/assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import AudioPreview from "@/components/NewsModule/AudioPreview";
import VideoPreview from "@/components/NewsModule/VideoPreview";
import CustomToaster from "../components/Common/CustomToaster";

export default {
  name: "DashBoard",
  components: {
    AudioPreview,
    VideoPreview
  },
  computed: {},
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      isActive:'uploaded',
      isCreateNewsPopUp: false,
      newsData: null,
      newActiveList: [],
      limit: 0,
      showData: false,
      recordedAudio: null,
      recordedVideo: null,
      openAudioVideo: false, 
      secondsOnly: 10,
      clickedNewsData: null  
    };
  },
  methods: { 
    changeStatus(newsStatus) {
      this.$cookie.set("news_status", newsStatus);
      this.isActive = newsStatus;
      this.limit = 0
      this.showData = false,
      this.openAudioVideo = false
      this.$store.dispatch({type: 'getNews', payload: {activeState: this.isActive, limit: this.limit} }).then((data)=>{
        this.showData = true
        this.newsData = data.data
      }).catch((err)=>{
        console.log(err)
      })
    },
    openFile(data){
      console.log('===clicked===', data)
      this.openAudioVideo = true
      this.clickedNewsData = data
      if(data.type === 'mp3'){
        this.recordedAudio = data.news_url
      }else{
        this.recordedVideo = data.news_url
      }
    },
    handleLoadMore(){
      this.limit += 10
      console.log('=this.limit==', this.limit)
      this.$store.dispatch({type: 'getNews', payload: {activeState: this.isActive, limit: this.limit} }).then((data)=>{
        this.showData = true
        console.log('==data=',data.data)
        if(data.data.length){
          this.newsData = this.newsData.concat(data.data)
        }
      }).catch((err)=>{
        console.log(err)
      })
    },
    goBack(){
      this.$router.go(-1)
    }
  },

  mounted() {
    this.$store.dispatch({type: 'getNews', payload: {activeState: this.isActive, limit: this.limit} }).then((data)=>{
      this.showData = true
      console.log('==data.data=', data.data)
      this.newsData = data.data
    }).catch((err)=>{
      console.log(err)
    })
  }
};
</script>

